import { useState } from 'react';
import { callUIAPI } from '../../../utils/apiUtils';
import * as apiConstants from '../../../utils/apiUtilsConstants';

/**
 * Props:
 *   firm         – the firm object (needs .id, .aiSuspended, .deepScanAllowed, .aiCostLimit, .aiMonthSpent)
 *   onFirmUpdate – callback invoked with the firm after the suspension changes
 */
const FirmAiBudget = ({ firm, onFirmUpdate }) => {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const save = async (path, payload, patch, failure) => {
    try {
      setSaving(true);
      setError(null);
      await callUIAPI(`bo/firms/${firm.id}/${path}`, payload, apiConstants.METHOD_PUT, true);
      onFirmUpdate({ ...firm, ...patch });
    } catch (err) {
      setError(err?.response?.data?.message || failure);
    } finally {
      setSaving(false);
    }
  };

  const handleToggle = (event) => {
    const suspended = event.target.checked;
    return save('ai-suspension', { suspended }, { aiSuspended: suspended }, 'Failed to update AI suspension.');
  };

  const handleDeepScanToggle = (event) => {
    const allowed = event.target.checked;
    return save('deep-scan-access', { allowed }, { deepScanAllowed: allowed }, 'Failed to update deep scan access.');
  };

  return (
    <div className="firm-field-section">
      <h3 className="firm-field-label">AI usage</h3>
      <p className="firm-field-value">
        ${Number(firm.aiMonthSpent ?? 0).toFixed(2)} spent this month of a ${Number(firm.aiCostLimit ?? 0).toFixed(2)} budget
      </p>
      <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#374151', cursor: 'pointer' }}>
        <input
          type="checkbox"
          checked={!!firm.aiSuspended}
          disabled={saving}
          onChange={handleToggle}
          style={{ accentColor: '#4f46e5' }}
        />
        Suspend AI
      </label>
      <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', color: '#374151', cursor: 'pointer' }}>
        <input
          type="checkbox"
          checked={!!firm.deepScanAllowed}
          disabled={saving}
          onChange={handleDeepScanToggle}
          style={{ accentColor: '#4f46e5' }}
        />
        Allow deep scan on trial
      </label>
      {error && <p className="firm-field-error">{error}</p>}
    </div>
  );
};

export default FirmAiBudget;
